import { getRouteApi } from '@tanstack/react-router';
import { OnboardingAuditField, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { Container, Spinner, Stack, Table, TableProvider, useTableState } from '@optimus-web/core';
import { marketplaceSelect } from './utils';
import { columns } from './columns';

const IntegrationRoute = getRouteApi('/_authenticated/$currentEnterpriseId/Settings/GoLiveAudits/Integrations');

export const IntegrationsTab = () => {
    const { currentEnterpriseId } = IntegrationRoute.useParams();
    const [tableState, setTableState] = useTableState<OnboardingAuditField>();

    const { data, isRefetching } = useRepositorySuspenseQuery(
        'enterprises',
        'getOnboardingAudit',
        { enterpriseId: currentEnterpriseId },
        {
            refetchOnWindowFocus: 'always',
            select: marketplaceSelect,
        }
    );

    return (
        <Container>
            <Stack alignment="end">{isRefetching ? <Spinner size="small" /> : null}</Stack>
            <TableProvider columns={columns} state={tableState} onStateChange={setTableState}>
                <Table data={data} amountOfRows={data.length} uniqueRowId="fieldIdentifier" />
            </TableProvider>
        </Container>
    );
};
